module.exports = __webpack_public_path__ + "img/img-9.91f210d7.webp";